export const CERTIFICATION_DOMAIN = {
  ASC: -1, //VIP Portal only certification domain
  DEV: 1,
  HM: 3,
  SVC: 4,
  VRT: 6,
  SAF: 19,
  SEC: 20,
  DATA: 22,
  PPL: 23,
  SPM: 25
};

export const CERTIFICATION_DOMAIN_EXPERIENCE_ROLE = {
  ATM: 1,
  ATL: 2,
  TOTAL: 3
};
